import { z } from 'zod';
import { TDetailedErrorResponse } from 'src_server/trpc/types/error';

export const InputSchema = z.object({
    email: z.string(),
    oldEmail: z.string(),
});

export type ChangeEmailInput = z.infer<typeof InputSchema>;

export const InputSchemaToUpdate = z.object({
    email: z.string(),
});

export type ChangeEmailInputToUpdate = z.infer<typeof InputSchemaToUpdate>;

export const SuccessResponseSchema = z.object({
    email: z.string(),
});

export type ChangeEmailSuccessResponse = z.infer<typeof SuccessResponseSchema>;

export type TChangeEmailsResponseType =
    | { responseStatus: 'success'; data: ChangeEmailSuccessResponse }
    | { responseStatus: 'error'; data: TDetailedErrorResponse };
